(function () {
  const sections = document.querySelectorAll('[data-pm-glute-ultra]');

  sections.forEach((section) => {
    const mainImage = section.querySelector('[data-pmg-main-image]');
    const thumbs = Array.from(section.querySelectorAll('[data-pmg-thumb]'));
    const galleryStage = section.querySelector('.pmg-gallery__stage');
    const previousButton = section.querySelector('[data-pmg-gallery-prev]');
    const nextButton = section.querySelector('[data-pmg-gallery-next]');
    const currentCounter = section.querySelector('[data-pmg-gallery-current]');
    const totalCounter = section.querySelector('[data-pmg-gallery-total]');
    const variantSelect = section.querySelector('[data-pmg-variant-select]');
    const variantInput = section.querySelector('[data-pmg-variant-input]');
    const price = section.querySelector('[data-pmg-price]');
    const comparePrice = section.querySelector('[data-pmg-compare-price]');
    const submit = section.querySelector('[data-pmg-submit]');

    let activeImageIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const showGalleryImage = (index) => {
      if (!mainImage || !thumbs.length) return;
      activeImageIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeImageIndex];
      galleryStage?.classList.add('is-changing');
      window.setTimeout(() => {
        mainImage.src = thumb.dataset.image;
        mainImage.alt = thumb.dataset.alt || '';
        mainImage.onload = () => galleryStage?.classList.remove('is-changing');
        window.setTimeout(() => galleryStage?.classList.remove('is-changing'), 260);
      }, 90);
      thumbs.forEach((item, thumbIndex) => {
        item.classList.toggle('is-active', thumbIndex === activeImageIndex);
        item.setAttribute('aria-current', thumbIndex === activeImageIndex ? 'true' : 'false');
      });
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (currentCounter) currentCounter.textContent = String(activeImageIndex + 1);
    };

    if (totalCounter) totalCounter.textContent = String(thumbs.length);
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showGalleryImage(index)));
    previousButton?.addEventListener('click', () => showGalleryImage(activeImageIndex - 1));
    nextButton?.addEventListener('click', () => showGalleryImage(activeImageIndex + 1));

    let pointerStartX = null;
    galleryStage?.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button, a, input')) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerStartX = event.clientX;
      galleryStage.setPointerCapture?.(event.pointerId);
    });
    galleryStage?.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 42) return;
      showGalleryImage(activeImageIndex + (distance < 0 ? 1 : -1));
    });
    galleryStage?.addEventListener('pointercancel', () => { pointerStartX = null; });

    if (variantSelect && variantInput) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        variantInput.value = variantSelect.value;
        if (price) price.textContent = option.dataset.price || '';
        if (comparePrice) {
          comparePrice.textContent = option.dataset.compare || '';
          comparePrice.hidden = !option.dataset.compare;
        }
        if (submit) {
          const available = option.dataset.available === 'true';
          submit.disabled = !available;
          submit.querySelector('span').textContent = available ? 'Añadir al carrito' : 'Agotado';
        }
      });
    }

    const sticky = section.querySelector('[data-pmg-sticky]');
    const mainForm = section.querySelector('[data-pmg-main-form]');
    if (sticky && mainForm && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0.08 });
      observer.observe(mainForm);
    }

    section.querySelectorAll('[data-pmg-scroll-to-buy]').forEach((button) => {
      button.addEventListener('click', () => {
        mainForm?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    const science = section.querySelector('[data-pmg-science]');
    if (science) {
      const scienceTabs = Array.from(science.querySelectorAll('[data-pmg-science-tab]'));
      const sciencePanels = Array.from(science.querySelectorAll('[data-pmg-science-panel]'));
      const scienceNumber = science.querySelector('[data-pmg-science-number]');
      const scienceLabel = science.querySelector('[data-pmg-science-label]');
      scienceTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.pmgScienceTab;
          scienceTabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          sciencePanels.forEach((panel) => {
            const active = panel.dataset.pmgSciencePanel === target;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
          if (scienceNumber) scienceNumber.textContent = tab.dataset.number || '';
          if (scienceLabel) scienceLabel.textContent = tab.dataset.label || '';
        });
      });
    }

    section.querySelectorAll('[data-pmg-before-after]').forEach((comparison) => {
      const range = comparison.querySelector('[data-pmg-ba-range]');
      if (!range) return;
      const updatePosition = () => comparison.style.setProperty('--pmg-ba-position', `${range.value}%`);
      range.addEventListener('input', updatePosition);
      updatePosition();
    });

    const resultTabs = Array.from(section.querySelectorAll('[data-pmg-result-tab]'));
    const resultComparison = section.querySelector('[data-pmg-results] [data-pmg-before-after]');
    resultTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        resultTabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (resultComparison && tab.dataset.image) {
          resultComparison.style.setProperty('--pmg-ba-image', `url("${tab.dataset.image}")`);
        }
      });
    });

    const planner = section.querySelector('[data-pmg-planner]');
    if (planner) {
      const plannerTabs = Array.from(planner.querySelectorAll('[data-pmg-planner-tab]'));
      const plannerPanels = Array.from(planner.querySelectorAll('[data-pmg-planner-panel]'));
      plannerTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.pmgPlannerTab;
          plannerTabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          plannerPanels.forEach((panel) => {
            const active = panel.dataset.pmgPlannerPanel === target;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    }

    const week = section.querySelector('[data-pmg-week]');
    if (week) {
      const weekRange = week.querySelector('[data-pmg-week-range]');
      const weekDays = week.querySelector('[data-pmg-week-days]');
      const weekSummary = week.querySelector('[data-pmg-week-summary]');
      const updateWeek = () => {
        const days = Number(weekRange?.value || 3);
        if (weekDays) weekDays.textContent = String(days);
        if (weekSummary) weekSummary.textContent = `${days} sesiones · ${days * 15} minutos semanales`;
      };
      weekRange?.addEventListener('input', updateWeek);
      updateWeek();
    }
  });
})();
